<div
  class="content-wrapper {{ _maxHeightClass() }}"
  [style]="{ maxHeight: _maxHeight() }"
>
  <ng-content />
  <div class="show-more-element-wrapper">
    <ng-container
      [ngTemplateOutlet]="_loadMoreTpl()"
      [ngTemplateOutletContext]="{
        $implicit: showMoreToggle.bind(this),
        expanded: expandArea(),
      }"
    />
  </div>
</div>

<ng-template #defaultLoadMoreTpl let-toggleFun let-expanded="expanded">
  <div class="bg-default">
    <a class="text-link text-semibold" (click)="toggleFun()">
      <span>{{ expanded ? 'Show less' : 'Show more' }}</span>
    </a>
  </div>
</ng-template>
